<template>
  <h3 class="font-semibold text-gray-700 text-xl">{{ title }}</h3>
  <div id="chart4">
    <apexchart
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "AELiquidationsQueryByProviderShowProviderLiquidationWeekly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    title: { default: '' },
    y_label: { default: '' },
    formatter: { required: true }
  },
  data() {},
  computed: {
    series() {
      return [
        {
          name: "Kilos Exportados",
          data: this.data_ok,
          type: 'bar'
        },
        {
          name: "Monto Pagado",
          data: this.data_weekly,
          type: 'line'
        }
      ];
    },
    options() {
      return {
        chart: {
          type: "line",
          height: 350,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        stroke: {
          width: [0, 4]
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [2],
          formatter: function (val) {
            return this.numberWithPrecision(val, 2);
          }.bind(this)
        },
        markers: {
          size: 0,
          style: "hollow"
        },
        xaxis: {
          tickPlacement: "between",
          group: {
            groups: this.groups,
            style: {
              fontSize: "14px",
              fontWeight: 500
            }
          }
        },
          yaxis: [
            {
              title: { text: "Kilogramos" },
              show: true,
              labels: {
                formatter: function (val) {
                  return this.numberWithPrecision(val, 0);
                }.bind(this)
              }
            },
            {
              title: { text: this.y_label },
              show: false,
              opposite: true,
              labels: {
                formatter: this.formatter.bind(this)
              }
            },
          ],
          tooltip: {
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
        },
        colors: [
          "#65A30D",
          "#3b82f6",
          "#CC3333",
          "#f97316",
        ]
      };
    },
    data_ok() {
      return Object.values(this.data)
        .flat()
        .map(harvest => {
          return {
            x: `${harvest.week}`,
            y: harvest.ok
          };
        });
    },
    data_weekly() {
      return Object.values(this.data)
        .flat()
        .map(harvest => {
          return {
            x: `${harvest.week}`,
            y: harvest.total_amount
          };
        });
    },
    groups() {
      return Object.keys(this.data).map(key => {
        return {
          title: key,
          cols: this.data[key].length
        };
      });
    }
  }
};
</script>
